module.exports = __webpack_public_path__ + "static/media/service17.b412e324.jpg";